import React from "react";
import { Svg } from "../componet/Form/style";

function Icon() {
  return (
    <Svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="12"
      fill="none"
      viewBox="0 0 16 12"
      email="true"
    >
      <path
        stroke="#CE6C80"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.28"
        d="M2.876 1.066h10.236c.704 0 1.28.576 1.28 1.28v7.677c0 .704-.576 1.28-1.28 1.28H2.876c-.704 0-1.28-.576-1.28-1.28V2.346c0-.704.576-1.28 1.28-1.28z"
      ></path>
      <path
        stroke="#CE6C80"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.28"
        d="M14.391 2.346L7.994 6.824 1.596 2.346"
      ></path>
    </Svg>
  );
}

export default Icon;
